// extracted by mini-css-extract-plugin
export default {"button":"styles_button__NxYuK","primary":"styles_primary__dCMRo","secondary":"styles_secondary__RXXq6","third":"styles_third__MAwxn","crossed":"styles_crossed__5M5ji"};